import { useTranslation } from 'react-i18next';
import SkynetIconButton from '../Fundamentals/IconButton/SkynetIconButton';

const FeedbackListItem = ({ suggestion, remainingUpvotes, maxUpvotes, canWrite, pending, withDivider, onUpvote }) => {
    const { t } = useTranslation();

    const limitReached = remainingUpvotes != null && remainingUpvotes <= 0 && !suggestion.hasUpvoted;
    const disabled = !canWrite || limitReached || suggestion.isOwn || pending;
    const title = suggestion.isOwn ? t('feedback.ownSuggestion') : limitReached ? t('feedback.limitReached', { max: maxUpvotes }) : t('feedback.upvoteTitle');

    return (
        <div className={`d-flex align-items-start gap-12 py-12${withDivider ? ' border-top' : ''}`}>
            <div className="feedback-suggestion-text flex-1 pt-2">{suggestion.suggestion}</div>
            <div className="feedback-upvote d-flex align-items-center gap-4 ml-auto align-self-center">
                <SkynetIconButton
                    icon="star"
                    iconActive="star-filled"
                    active={suggestion.hasUpvoted}
                    disabled={disabled}
                    onClick={onUpvote}
                    label={t('feedback.upvoteTitle')}
                    title={title}
                />
                <span className="feedback-upvote-count text-left semibold">{suggestion.upvoteCount}</span>
            </div>
        </div>
    );
};

export default FeedbackListItem;
